export const USER_ROLES = {
  RU_PAYMENT: "RU_PAYMENT",
  RESPONSIBLE: "RESPONSIBLE",
  FINANCE_ACCOUNT_INFO: "FINANCE_ACCOUNT_INFO",
  OWB_MS_PRD_INVOICES: "OWB_MS_PRD_INVOICES",
  RU_PAYMENTS_CONTROL: "RU_PAYMENTS_CONTROL",
  HOLDING_ACCOUNTS: "HOLDING_ACCOUNTS",
  TARIFFS_TARIFF_ORDER: "TARIFFS_TARIFF_ORDER",
  OWB_MS_PRD_RKO_ORDERS: "OWB_MS_PRD_RKO_ORDERS",
  RESPONSIBLE_FOR_LEGAL: "RESPONSIBLE_FOR_LEGAL",
  OWB_MS_PRD_SALARY: "OWB-MS-PRD-SALARY",
  BUSINESS_CARD: "BUSINESS_CARD",
  DEPOSIT: "DEPOSIT",
  RESPONSIBLE_FOR_MERCHANT: "RESPONSIBLE_FOR_MERCHANT",
  CURRENCY: "CURRENCY",
  CERT_CURR_TRANS: "CERT_CURR_TRANS",
  CREDIT_APPLICATION: "CREDIT_APPLICATION",
  SHOWCASE_VIEWER: "SHOWCASE_VIEWER",
  LOYALTY_PROGRAM: "LOYALTY_PROGRAM",
  OWB_MS_PRD_MS_H2H: "OWB-MS-PRD-MS-H2H",
  CM_ESPP_REGISTER_ACT: "CM_ESPP_REGISTER_ACT",
  MAIL_BANK: "MAIL_BANK",
  CM_ESCROW_REPORT_ACT: "CM_ESCROW_REPORT_ACT",
  MS_DBO_NOTIFICATION: "MS_DBO_NOTIFICATION",
  UI_DBO_NOTIFICATION_VIEW: "UI_DBO_NOTIFICATION_VIEW",
  UI_CONNECTOR_AUSN_VIEW: "UI_CONNECTOR_AUSN_VIEW",
  UI_PAYMENT_VISUAL_VIEW: "UI_PAYMENT_VISUAL_VIEW",
  CONTRACTOR: "CONTRACTOR",
  INFORM_MANAGEMENT: "inform-management",
  PROMISSORY_NOTE: "PROMISSORY-NOTE",
  OWB_MS_PRD_BROKERAGE_CLIENT_WITH_SIGN:
    "OWB_MS_PRD_BROKERAGE_CLIENT_WITH_SIGN",
  OWB_MS_PRD_ACCREDITIVS_CLIENT_SIGN: "owb-ms-prd-accreditivs_client-sign",
  OWB_MS_PRD_ACCREDITIVS_CLIENT_NO_SIGN:
    "owb-ms-prd-accreditivs_client-no-sign",
  SWIFT_MESSAGE_CLIENT: "SWIFT-MESSAGE_CLIENT",

  VISITOR: "VISITOR",

  currency: "currency",
  owb_ms_prd_mail: "owb-ms-prd-mail",
} as const;
